"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmRequestPayload = exports.CreateRequestPayload = exports.RequestType = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const field_1 = require("../../../openapi/field");
exports.NAMESPACE = 'Culligan.Api.V1.Frontend.Privacy.Schema';
exports.RequestType = effect_1.Schema.Literal('dataExport', 'dataErasure').annotations({
    identifier: `${exports.NAMESPACE}.RequestType`,
    description: 'dataExport requests a copy of the data, dataErasure requests its deletion',
});
const emailDescription = 'Email address of the data subject. The server lower-cases it before use.';
const langDescription = 'Two-letter language code (any two characters, not checked against a language list). Defaults to "en" when omitted.';
exports.CreateRequestPayload = effect_1.Schema.Struct({
    email: effect_1.Schema.propertySignature(effect_1.Schema.String.annotations({ jsonSchema: { type: 'string', format: 'email' } })).annotations({ description: emailDescription }),
    type: effect_1.Schema.propertySignature(exports.RequestType).annotations({ description: 'Kind of privacy request' }),
    lang: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.length(2)), { exact: true }).annotations({
        description: langDescription,
    }),
    appId: (0, field_1.nonEmpty)('Client application id. Must belong to a registered, enabled client application, otherwise the request is rejected with 422.'),
}).annotations({
    identifier: `${exports.NAMESPACE}.CreateRequestPayload`,
    description: 'Request body to create a privacy request (data export or erasure)',
});
exports.ConfirmRequestPayload = effect_1.Schema.Struct({
    id: (0, field_1.nonEmpty)('Id of the privacy request to confirm'),
}).annotations({
    identifier: `${exports.NAMESPACE}.ConfirmRequestPayload`,
    description: 'Request body to confirm a privacy request',
});
//# sourceMappingURL=schema.js.map